<template>
  <div id='app'>
    <layout-header />
    <layout-main />
    <layout-footer />
  </div>
</template>

<script>
import LayoutHeader from "./layout/Header";
import LayoutMain from "./layout/Main";
import LayoutFooter from "./layout/Footer";
export default {
  name: "App",
  components: {
    LayoutHeader,
    LayoutMain,
    LayoutFooter
  }
};
</script>


